module.exports = __webpack_public_path__ + "img/N121-2-EN.60320322.png";